import React, { useState } from "react";
import API from "../api.js";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");

    try {
      const res = await API.post("/users/login", { email, password });

      setMessage(res.data.message || "✅ Login successful!");

      if (res.data.token) {
        localStorage.setItem("token", res.data.token);
        localStorage.setItem("userId", res.data.user.id);
        localStorage.setItem("userName", res.data.user.name);
        localStorage.setItem("userEmail", res.data.user.email);

        setTimeout(() => {
          window.location.href = "/";
        }, 1200);
      }
    } catch (err) {
      const errorMsg =
        err.response?.data?.message ||
        "⚠️ Something went wrong! Please try again.";
      setMessage(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-[#FAF6EF] to-[#E8DCCB]">
      <form
        onSubmit={handleSubmit}
        className="bg-white/90 backdrop-blur p-8 w-96
                   rounded-3xl
                   shadow-[0_20px_40px_rgba(0,0,0,0.15)]
                   transition-transform duration-300 hover:scale-[1.02]"
      >
        <h2
          className="text-3xl font-extrabold mb-2 text-center"
          style={{ color: "#3A2A1A" }}
        >
          Welcome Back
        </h2>

        <p className="text-center text-sm mb-6 text-[#6B4A2D]">
          Continue your learning journey ✨
        </p>

        {/* Email */}
        <input
          type="email"
          placeholder="Email address"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full p-3 mb-4
                     border border-[#D8C7B0]
                     rounded-xl
                     focus:outline-none
                     focus:ring-2 focus:ring-[#C08A5A]"
          required
        />

        {/* Password */}
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="w-full p-3 mb-6
                     border border-[#D8C7B0]
                     rounded-xl
                     focus:outline-none
                     focus:ring-2 focus:ring-[#C08A5A]"
          required
        />

        {/* Button */}
        <button
          type="submit"
          disabled={loading}
          className={`w-full py-2.5 rounded-xl text-white font-semibold text-lg transition ${
            loading
              ? "bg-gray-400 cursor-not-allowed"
              : "bg-[#8B5A2B] hover:bg-[#7A4A28]"
          }`}
        >
          {loading ? "Logging in..." : "Login"}
        </button>

        {/* Forgot Password */}
        <div className="text-center mt-4">
          <a
            href="/forgot-password"
            className="text-sm text-[#8B5A2B] hover:underline"
          >
            Forgot your password?
          </a>
        </div>

        {/* Message */}
        {message && (
          <p
            className={`mt-4 text-center font-medium ${
              message.toLowerCase().includes("verify")
                ? "text-yellow-600"
                : message.toLowerCase().includes("success")
                ? "text-green-700"
                : "text-red-600"
            }`}
          >
            {message}
          </p>
        )}

        {/* Signup */}
        <div className="mt-6 text-center text-sm text-[#5C4632]">
          Don’t have an account?{" "}
          <a
            href="/signup"
            className="font-semibold text-[#8B5A2B] hover:underline"
          >
            Sign Up
          </a>
        </div>
      </form>
    </div>
  );
};

export default Login;
